<template>
  <div id="add-plan-template">
    <div class="main-wrapper">
      <div class="block-title">
        <el-badge value="new">
          <h2 class="title-name">腾讯3.0</h2>
        </el-badge>

        <div class="btns">
          <div class="left-aside-layout">
            <el-button class="btn config-btn" @click="showSettingsModal">批量方案配置 </el-button>
            <p>
              <span>当前登录人员剩余认证天数{{ authExpireDate }}</span>
              <el-button class="auth-btn" type="text" @click="onGdtAuthorize">去认证</el-button>
            </p>
          </div>
          <TemplateManagement :template-json="selectedTemplateInfo" :menu-id="GDT_MENU_ID" @confirm="onTemplateSelectConfirm" />
        </div>
      </div>
      <div class="block-main" v-loading="onTemplateSelectLoading">
        <MediaAccountSelector :media-id="MEDIAS.GDT" @setValue="onMediaAccountSelectConfirm" />
        <div class="config-cols">
          <el-row :gutter="12">
            <el-col :span="4">
              <ProjectConfigCol title="项目基础信息" :ref="(el) => (formColRefs[0] = el)"></ProjectConfigCol>
            </el-col>
            <el-col :span="4">
              <TargetingConfigCol title="投放版位/定向包"></TargetingConfigCol>
            </el-col>
            <el-col :span="4"> <CreativeConfigCol title="创意信息" :ref="(el) => (formColRefs[1] = el)"></CreativeConfigCol> </el-col>
            <el-col :span="8"> <MaterialCol title="创意素材"></MaterialCol> </el-col>
            <el-col :span="4">
              <div class="vertical-block">
                <DescriptionConfigCol class="desc" title="文案包"></DescriptionConfigCol>
                <LandingPageConfigCol class="landingpage" title="品牌形象及落地页"></LandingPageConfigCol>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="footer">
        <div class="plans-desc">
          <div class="col" v-for="(num, key) in displayPlanNums" :key="key">
            <p>{{ key }}</p>
            <p>{{ num }}</p>
          </div>

          <div class="result">
            <p>生成计划数量</p>
            <p>
              {{ generateTotalNum }}
            </p>
          </div>
        </div>

        <div class="preview-btn">
          <el-button type="primary" @click="validateAndMakePreviewTable">预览计划</el-button>
        </div>
      </div>

      <div class="preview-table" v-if="Object.values(previewOriginData).length">
        <div class="preview-table-header">
          <div class="accounts">
            <el-tag
              v-for="(account, index) in configForm.accounts"
              :key="account.id"
              :type="activeAccount === account.id ? '' : 'info'"
              @click="onAcitveAccountChange(account.id)"
            >
              <span> 账号{{ index + 1 }}：{{ account.adAccount }}</span>
              <span>（{{ getAvailableNums(account) }}）</span>
            </el-tag>
          </div>
          <el-button type="primary" @click="onSubmitValidate">提交选中计划</el-button>
        </div>
        <PreviewTable
          :active-account="activeAccount"
          :table-data="tableData"
          :targetings="targetPackages"
          :creatives="creativeGroups"
          :table-form="tableFormFilteredByAccount"
          @update-table-data="updateTableData"
          @update-table-form="updateTableForm"
        >
          <template #planName="slotProps">
            <div class="plan-name">
              <el-input
                v-model="slotProps.row.plan.project_name"
                @input="onPlanNameInput($event, slotProps.row)"
                placeholder="请输入计划名称"
              ></el-input>
              <p class="project-name-error-msg">
                <span v-if="!slotProps.row.plan.project_name">计划名称不能为空</span>
                <span v-else-if="duplicateNameError === slotProps.row.plan.project_name">计划名称不能重复</span>
              </p>
            </div>
          </template>
        </PreviewTable>
      </div>
    </div>

    <BatchPlanConfigModal ref="batchPlanModalRef" @setValue="onTemplateConfigConfirm" />

    <el-dialog
      title="提交计划确认"
      :visible.sync="submitConfirmModal"
      :close-on-click-modal="false"
      custom-class="before-submit-modal"
      style="margin-top: 22vh"
      width="360px"
    >
      <el-form inline @submit.native.prevent>
        <el-form-item prop="name" label="模板名称">
          <el-input style="width: 100%" v-model.trim="submitSaveTemplateName" placeholder="请输入模板名称"></el-input>
          <p style="font-size: 12px">需保存模板名称时填写</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitCancel">取 消</el-button>
        <el-button type="primary" v-if="!!submitSaveTemplateName" :loading="submitLoading" @click="saveTemplateSubmit">
          保存模板后提交
        </el-button>
        <el-button type="primary" v-else :loading="submitLoading" @click="onSubmitConfirm">直接提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { getCookie } from '@/common/js/api.js'
import eventBus from '@/event-bus.js'
import { Message } from 'view-design'
import { MessageBox } from 'element-ui'
import { ref, computed, provide, nextTick } from 'vue'
import { clone, pick } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants.js'
import { gotoAuthorize, getAuthInfo, authCallbackHandler } from '@/common/js/gdtAuthUtil.js'
import { useRoute, useRouter } from 'vue-router/composables'

import { GDT_MENU_ID } from '@/views/create/gdt/model/project-const.js'

import TemplateManagement from '@/views/create/bytedance/components/template/index.vue'
import BatchPlanConfigModal from '@/views/create/bytedance/components/batchPlan/index.vue'
import MediaAccountSelector from '@/views/create/bytedance/components/account/index.vue'

import ProjectConfigCol from './components/project/index.vue'
import TargetingConfigCol from './components/targeting/index.vue'
import CreativeConfigCol from './components/creative/index.vue'
import DescriptionConfigCol from './components/creative/description.vue'
import LandingPageConfigCol from './components/creative/landingpage.vue'
import MaterialCol from './components/creative/material-list.vue'
import PreviewTable from './components/preview-table/index.vue'

import { useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'
import { usePlanDistribute } from './hooks/useGdtPlansPreview.js'
import { useTemplateManage } from './hooks/useGdtPlanTemplates.js'
import { getConfigFormModel } from './model/form.js'
const opId = getCookie('ch_op_id')
const configForm = ref(getConfigFormModel())
const route = useRoute()
const router = useRouter()
const updateConfigForm = (form) => {
  clearPreviewTable()
  configForm.value = form
}

provide('configForm', {
  configForm,
  updateConfigForm
})

provide('localStates', {
  opId: Number(opId),
  getAdAccount: () => configForm.value.accounts[0] || null
})

window.addEventListener('beforeunload', function (event) {
  event.preventDefault()
  event.returnValue = '您有未保存的更改，确定要离开吗？'
  return '您有未保存的更改，确定要离开吗？'
})

const {
  formColRefs,
  duplicateNameError,
  activeAccount,
  submitLoading,
  submitConfirmModal,
  submitSaveTemplateName,
  previewOriginData,
  targetPackages,
  creativeGroups,
  tableData,
  updateTableData,
  updateTableForm,
  tableStatesForm,
  onAcitveAccountChange,
  tableFormFilteredByAccount,
  onPlansValidate,
  onPlansPreview,
  onSubmitCancel,
  duplicateNameValidate,
  onSubmitValidate,
  onSubmitConfirm,
  saveTemplateSubmit
} = usePlanDistribute(configForm)

const { onTemplateSelectLoading, selectedTemplateInfo, onTemplateConfirm } = useTemplateManage(configForm)

const authExpireDate = ref('0天')

const getGdtAuthInfo = async () => {
  const dateText = await getAuthInfo()

  if (dateText) {
    authExpireDate.value = dateText
  } else {
    MessageBox.alert('腾讯投放需要扫码认证，你的投放认证已经失效或者未认证。', '提示', {
      confirmButtonText: '去认证',
      callback: (action) => {
        if (action === 'confirm') {
          onGdtAuthorize()
        }
      }
    })
  }
}

const { expire_time, user_token, user_status } = route.query || {}
if (expire_time && user_token) {
  authCallbackHandler({ expire_time, user_token }).then(() => {
    router.replace({ name: 'gdttemplate' })
    this.$Message.success('认证成功')
    getGdtAuthInfo()
  })
} else {
  if (expire_time === '0' && user_token === '') {
    Message.warning('认证失败，请联系管理员')
    this.$router.replace({ name: 'gdttemplate' })
  }
  getGdtAuthInfo()
}

const batchPlanModalRef = ref(null)
const showSettingsModal = () => {
  batchPlanModalRef.value.open()
}

const getAvailableNums = (account) => {
  const tableData = previewOriginData.value[account.id] || []
  const checkedRows = tableData.filter((row) => row.helper.isCheck)
  return `${checkedRows.length}/${tableData.length}`
}

const displayPlanNums = computed(() => {
  const nums = {}
  const { accounts, targetings, creatives, wxgamePlayableCreatives, creativeForm, descriptions, template } = configForm.value
  const { isWxGamePlayable } = useGdtCreativeComputes(creativeForm)
  const { adNumber, accountAllocation } = template
  const keys = []

  if (adNumber === 1 && accountAllocation === 1) keys.push('定向包', '素材组', '账号')
  // 按定向包分配
  if (adNumber === 2 && accountAllocation === 2) {
    if (targetings.length >= accounts.length) keys.push('定向包', '素材组')
    else {
      keys.push('素材组', '账号')
    }
  }
  if (adNumber === 3 && accountAllocation === 2) keys.push('素材组')
  if (adNumber === 3 && accountAllocation === 3) keys.push('素材组')

  nums['定向包'] = targetings.length
  nums['素材组'] = creatives.length
  nums['账号'] = accounts.length

  return pick(nums, keys)
})
const generateTotalNum = computed(() => {
  const arr = Object.values(displayPlanNums.value)
  if (!arr.length) return 0
  return arr.reduce((acc, c) => acc * c, 1)
})

async function validateAndMakePreviewTable() {
  try {
    await onPlansValidate()
    onPlansPreview()

    const tableStates = {}
    configForm.value.accounts.forEach((account) => {
      tableStates[account.id] = {
        projectSwitch: true,
        planSwitch: true,
        isCheckAll: true
      }
    })
    tableStatesForm.value = tableStates
  } catch (e) {
    console.log('e.message output: ', e.message)
    const { index } = JSON.parse(e.message)
    if (index > -1) {
      formColRefs.value[index].openInvalidFormDrawer()
    }
  }
}

function onGdtAuthorize() {
  gotoAuthorize(window.location.href)
}

async function onTemplateSelectConfirm(row) {
  configForm.value = await onTemplateConfirm(row)

  // 选择模板更新批量方案配置
  batchPlanModalRef.value.updateConfig(configForm.value.template)

  clearPreviewTable()

  nextTick(() => {
    eventBus.$emit('gdtTemplateSelect')
  })
}

function onPlanNameInput(project_name, row) {
  const newData = clone(tableData.value).map((i) => {
    if (i.permanent_plan_name === row.permanent_plan_name) {
      i.plan.project_name = project_name
      return i
    }
    return i
  })

  updateTableData(newData)
  try {
    nextTick(duplicateNameValidate)
  } catch (e) {}
}

function onTemplateConfigConfirm(data) {
  configForm.value.template = data
  clearPreviewTable()
}

function clearPreviewTable() {
  previewOriginData.value = {}
}
function onMediaAccountSelectConfirm(data) {
  configForm.value.accounts = data

  eventBus.$emit('gdtTemplateAccountChange', data)
}
</script>
<style scoped lang="scss">
#add-plan-template {
  height: 100vh;
  padding: 16px;
  margin-bottom: 0;
  overflow: auto;
  ::v-deep .el-tag--info {
    color: #666;
    cursor: pointer;
  }
  ::v-deep .el-table .el-table__header-wrapper th .cell {
    color: #333;
  }
  .main-wrapper {
    min-width: 1600px;
    background: #fff;
    padding: 16px;

    .block-title {
      display: flex;
      align-items: center;
      .title-name {
        font-size: 18px;
        font-weight: 600;
      }

      .btns {
        margin-left: 32px;
        flex: 1;
        display: flex;
        justify-content: space-between;

        .left-aside-layout {
          display: flex;
          align-items: center;
          p {
            margin-left: 10px;
            .auth-btn {
              margin-left: 5px;
            }
          }
        }
        .btn {
          font-size: 14px;
        }
        .config-btn {
          background: #ebedf0;
          color: #000;
        }
      }
    }

    .block-main {
      .top-form {
        margin-top: 10px;
      }

      .config-cols {
        height: 758px;
        .vertical-block {
          display: flex;
          flex-direction: column;

          .landingpage {
            margin-top: 10px;
          }
        }

        ::v-deep .block-title {
          display: flex;
          align-items: flex-end;
          h4 {
            color: #000;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
          }
          > span {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 12px;
    border-top: 1px solid #eee;
    background-color: #fff;
    min-width: 1600px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .plans-desc {
      margin-right: 56px;
      display: flex;
      align-items: center;
      .col,
      .result {
        position: relative;
        margin-right: 40px;
        p:first-child {
          margin-bottom: 10px;
        }
        p:last-child {
          font-weight: 600;
          font-size: 14px;
          text-align: center;
        }
      }
      .col {
        &:not(:first-child)::after {
          content: '×';
          color: #bbb;
          position: absolute;
          left: -26px;
          top: 40%;
          margin-top: -8px;
          font-size: 20px;
        }
      }

      .result {
        margin-right: 0;
        &::after {
          content: '=';
          color: #bbb;
          position: absolute;
          left: -26px;
          top: 50%;
          margin-top: -8px;
          font-size: 18px;
        }
      }
    }
    .preview-btn {
      button {
        background: #1974ff;
        margin: 0 !important;
      }
    }
  }

  .preview-table {
    border: 1px solid #eee;
    border-radius: 4px;
    padding: 12px;
    .preview-table-header {
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .accounts {
        .el-tag {
          margin-right: 10px;
        }
      }
    }

    .project-name-error-msg {
      color: red;
      margin-top: 2px;
    }
  }

  .bottom-gap {
    padding: 50px;
  }
}
</style>
